var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-bottom":"50px !important"},attrs:{"id":"header"}},[_c('div',{staticClass:"container d-flex flex-column align-items-center"},[_c('h1',[_vm._v("Witaj Administratorze!")]),_c('h3',[_vm._v("Cieszymy się, że jesteś z Nami!")]),_c('SearchBar')],1),_c('AdminPageContainers')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }